import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import draggable from '../hoc/draggable';
import { sliderClass } from './styles';

var Indicator =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Indicator, _PureComponent);

  var _super = _createSuper2(Indicator);

  function Indicator() {
    _classCallCheck(this, Indicator);

    return _super.apply(this, arguments);
  }

  _createClass(Indicator, [{
    key: "render",
    value: function render() {
      var event = this.props.disabled ? undefined : this.props.onDragStart;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onMouseDown: event,
          className: sliderClass('indicator')
        })
      );
    }
  }]);

  return Indicator;
}(PureComponent);

export default draggable(Indicator);